import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, ConfigProvider, Modal, Input } from "antd";
import axios from "axios";
import style from "css/app.module.css";
import { Cookies } from "react-cookie";
import { insertUserInfo } from "redux/slices/userSlice";
import { insertAllowPageInfo } from "redux/slices/allowPageSlice";
import { useTranslation } from "react-i18next";
import { openAlert, openConfirm, closeAlert } from "redux/slices/alertSlice";

function ZoomIdModal(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [zoomId, setZoomId] = useState("");
  const closeModal = () => {
    setZoomId("");
    props.close();
  };
  const refreshInfo = () => {
    axios
      .get("/user/refresh/info")
      .then((res) => {
        if (res.status === 200) {
          const memeberInfo = res.data.MEMBER_INFO;

          dispatch(
            insertUserInfo({
              name: memeberInfo.MEMBER_NM,
              id: memeberInfo.MEMBER_ID,
              zoomId: memeberInfo.ZOOM_ID,
            })
          );

          const allowPages = res.data.ALLOW_PAGES;

          dispatch(insertAllowPageInfo({ pages: allowPages }));
        }
      })
      .catch(() => {
        const effectCookies = new Cookies();
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        effectCookies.remove(authNm, { path: "/", domain: domain });
        effectCookies.remove(refreshNm, { path: "/", domain: domain });
        window.location.href = process.env.REACT_APP_CLIENT_URL;
      });
  };
  const editUserInfo = () => {
    let param = {
      MEMBER_ID: props.memberId,
      ZOOM_ID: zoomId,
    };

    axios
      .put("/user/info", param)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: "알림",
            content: "사용자 정보가 수정되었습니다.",
            submitEventHandler: () => {
              closeModal();
              refreshInfo();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
        }
      })
      .catch((error) => {
        const obj = {
          title: "알림",
          content: "사용자 정보 수정 중 오류가 발생했습니다.",
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };
  return (
    <div className={style.zoom_id_modal}>
      <Modal
        open={props.open}
        onCancel={closeModal}
        maskClosable={false}
        footer={
          <div className={style.user_info_modal}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorPrimaryHover: "#1cb691",
                    colorPrimaryActive: "#1cb691",
                  },
                },
              }}
            >
              <Button onClick={closeModal}>{t("BTN.CANCEL")}</Button>
            </ConfigProvider>
            <Button
              type="primary"
              onClick={() => {
                const obj = {
                  title: "알림",
                  content: "사용자 정보를 수정하시겠습니까?",
                  submitEventHandler: () => {
                    editUserInfo();
                    dispatch(closeAlert());
                  },
                };
                dispatch(openConfirm(obj));
              }}
            >
              {t("BTN.SAVE")}
            </Button>
          </div>
        }
        width={480}
        centered
        closable={false}
      >
        <div className={style.user_info_item}>
          <p className={style.user_info_item_title}>줌 계정</p>
          <div>
            <Input
              className={style.user_info_item_input}
              type="primary"
              placeholder="테넌트에 등록된 줌 계정을 입력해주세요."
              value={zoomId}
              onChange={(e) => {
                setZoomId(e.target.value);
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ZoomIdModal;
